<template>
  <div>
    <div class="content-container">
      <header-box></header-box>
      <div class="content-box">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>
<script>
// import headerBox from '@/views/index/headerOld'
import headerBox from '@/views/index/header'
import global from '@/assets/js/global.js'
export default {
  name: 'index-index',
  components: {
    headerBox
  },
  data() {
    return {
      global: global
    }
  },
  computed: {
  },
  mounted() {
    document.title = '政协' + this.global.title + '委员会'
  },
  created() {
  },
  methods: {
  }
}
</script>
<style lang="scss">
.content-container {
  // background-color: #f9f9f9;
  // background: url("../../assets/img/bg.png") top center;
  // background-size: 40px;

  .content-box {
    // padding-bottom:20px ;
  }
}
</style>
